import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const useOrderConfirmLabels = (order)=>{
    var ref1;
    const { getLabel , getFormattedLabel  } = useIntl();
    return React.useMemo(()=>{
        var ref;
        return {
            title: getLabel('checkout.completed.title'),
            completed: getLabel('checkout.completed.message'),
            orderPlaced: {
                title: getFormattedLabel('checkout.completed.hero.alert.title', {
                    labelData: {
                        orderNumber: (order === null || order === void 0 ? void 0 : order.orderNumber) || ''
                    }
                }),
                message: getFormattedLabel('checkout.completed.hero.alert.message', {
                    labelData: {
                        customerEmail: (order === null || order === void 0 ? void 0 : (ref = order.customerDetails) === null || ref === void 0 ? void 0 : ref.email) || ''
                    }
                })
            },
            orderContainsSunglasses: getLabel('checkout.completed.cartContainsSunglasses'),
            orderContainsPrescriptionGlasses: getLabel('checkout.completed.cartContainsPrescriptionGlasses'),
            shipmentDetailsTitle: getLabel('checkout.completed.shipmentDetails.title'),
            yourDetails: getLabel('checkout.yourDetails'),
            orderDetailsHeader: getLabel('checkout.orders.header'),
            serviceStoreTitle: getLabel('checkout.serviceStore.title'),
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium')
            },
            error: {
                title: getLabel('checkout.errors.general.title'),
                message: getLabel('checkout.errors.general.message')
            }
        };
    }, [
        getFormattedLabel,
        getLabel,
        order === null || order === void 0 ? void 0 : (ref1 = order.customerDetails) === null || ref1 === void 0 ? void 0 : ref1.email,
        order === null || order === void 0 ? void 0 : order.orderNumber
    ]);
};

export { useOrderConfirmLabels };
//# sourceMappingURL=use-order-confirm-labels.js.map
